module.exports = __webpack_public_path__ + "static/media/logo-mastercard.040965cf.svg";